import ANALYTICS_DEBUG_MODE from "./analytics-debug-mode";

const DEBUG = ANALYTICS_DEBUG_MODE;

const trackEvent = function (name, params = {}) {
    if (typeof gtag === "function") {
        gtag('config', window.SiteConfig.ga, {
            'custom_map': {
                'metric1': 'leadtime',
                'dimension1': 'accountId',
                'dimension2': 'accountType',
                'dimension3': 'productList',
            },
        });

        gtag('event', name, params);

        if (DEBUG) {
            console.log('Event name:', name, {
                name: name,
                params: params,
            });
        }
    }
};

export default class AnalyticsTracker {
    trackImpression(items) {
        trackEvent('view_item_list', {
            items: items,
        });
    }

    trackRepeatOrder(items) {
        trackEvent('add_to_cart', {
            items: items
        })
    }

    trackClearCart(items) {
        trackEvent('remove_from_cart', {
            items: items
        })
    }

    trackAddToCart(id, name, listName, listPosition, quantity, price, leadtime, accountId, accountType) {
        trackEvent('add_to_cart', {
            items: [
                {
                    id: id,
                    name: name,
                    list_name: listName,
                    list_position: listPosition,
                    productList: listName,
                    quantity: quantity,
                    price: price,
                    accountId: accountId,
                    accountType: accountType,
                    leadtime: leadtime,
                },
            ],
        });
    }

    trackChangeQuantityToCart(id, name, listName, listPosition, quantity, price, leadtime, accountId, accountType) {
        trackEvent('change_quantity_to_cart', {
            items: [
                {
                    id: id,
                    name: name,
                    list_name: listName,
                    list_position: listPosition,
                    productList: listName,
                    quantity: quantity,
                    price: price,
                    accountId: accountId,
                    accountType: accountType,
                    leadtime: leadtime,
                },
            ],
        });
    }

    trackRemoveFromCart(id, name, quantity, price, leadtime, accountId, accountType) {
        trackEvent('remove_from_cart', {
            items: [
                {
                    id: id,
                    name: name,
                    quantity: quantity,
                    price: price,
                    accountId: accountId,
                    accountType: accountType,
                    leadtime: leadtime,
                },
            ],
        });
    }

    trackBeginCheckout(items) {
        trackEvent('begin_checkout', {
            items: items,
        });
    }

    trackCheckoutProgress(items) {
        trackEvent('checkout_progress', {
            items: items,
        });
    }

    trackAddPaymentInfo(items) {
        trackEvent('add_payment_info', {
            items: items,
        });
    }

    trackCheckoutOptions(step, option, value) {
        trackEvent('set_checkout_option', {
            checkout_step: step,
            checkout_option: option,
            value: value,
        });
    }

    trackPurchase(id, value, items) {
        trackEvent('purchase', {
            transaction_id: id,
            value: value,
            items: items,
        });
    }

    trackContactForm() {
        trackEvent('contactformulier', {});
    }

    trackContactSpecificQuestion() {
        trackEvent('contactformulier_specifiekevraag', {});
    }

    trackMailClick() {
        trackEvent('mail_click', {});
    }

    trackTelClick() {
        trackEvent('tel_click', {});
    }

    trackTelClickRequestArticleInformation() {
        trackEvent('tel_click_request_article_information', {});
    }

    trackViewShoppingCart(items) {
        trackEvent('view_cart', {
            items: items,
        });
    }

    trackAddShippingInfo() {
        trackEvent('add_shipping_info ', {});
    }

    /**
     * @uses into AnalyticsService() resources/assets/js/helpers/analytics.service.js
     */
    trackLogin() {
        trackEvent('login ', {});
    }
}
